/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Added_DescriptionInputs */



/**
* | output |
* | --- |
* | "Event exists in Group B but not in Group A" |
*
* @param {Compare_Event_Groups_Added_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_added_description = /** @type {((inputs?: Compare_Event_Groups_Added_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Added_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("L'événement existe dans le groupe B mais pas dans le groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Ereignis existiert in Gruppe B, aber nicht in Gruppe A.")
	if (locale === "it") return /** @type {LocalizedString} */ ("L'evento esiste nel Gruppo B ma non nel Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие существует в группе B, но отсутствует в группе A.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El evento existe en el Grupo B pero no en el Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("该事件存在于B组中，但不存在于A组中。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントはグループ B には存在するがグループ A には存在しない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह घटना समूह B में मौजूद है लेकिन समूह A में नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O evento existe no Grupo B, mas não no Grupo A.")
	return /** @type {LocalizedString} */ ("Event exists in Group B but not in Group A")
});